export const PRICE_ALERTS_MODAL_WIDTH = "428px";

export const PRICE_ALERTS_EMAIL_SECOND = 60;
